module.exports = require("./os-RU.d.ts");